import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationItemModule } from '@app/core/header/components/notifications/notification-item/notification-item.module';
import { NotificationsComponent } from '@app/core/header/components/notifications/notifications.component';
import { MmaoService } from '@app/shared/components/mmao/services/mmao.service';
import { MmaoModule } from '@app/shared/components/mmao/mmao.module';

@NgModule({
  imports: [CommonModule, NotificationItemModule, MmaoModule],
  providers: [MmaoService],
  declarations: [NotificationsComponent],
  exports: [NotificationsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class NotificationsModule {}
